<template>
    <div class="rf-view">
        <NavigationBar :title="$t('settings.profiles.title')">
            <BackButton v-if="canPop" slot="left" @click="pop" />
            <button class="button text" slot="right" @click="addProfile">{{ $t('buttons.add') }}</button>
        </NavigationBar>
        <main>
            <h1>
                {{ $t('settings.profiles.title') }}
            </h1>

            <List>
                <ListItem v-for="customer in customerList" :key="customer.id" element-name="label" :selectable="true">
                    {{ customer.settings.businessName }}

                    <Radio slot="right" v-model="selectedProfile" :value="customer.id" name="customerId" />
                </ListItem>
            </List>
        </main>
    </div>
</template>


<script lang="ts">
import { BackButton, List, ListItem, NavigationBar, Radio } from "@restofrit/components";
import { Session } from "@restofrit/networking";
import { Customer, User } from "@restofrit/structures";
import { ArrayDecoder, Decoder } from "@simonbackx/simple-encoding";
import { ComponentWithProperties, NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins, Prop } from "vue-property-decorator";
import ChooseWholesalerView from "../create-customer/ChooseWholesalerView.vue";

@Component({
    components: {
        NavigationBar,
        List, 
        ListItem,
        Radio,
        BackButton
    },
})
export default class ProfileSelectionView extends Mixins(NavigationMixin) {
    @Prop({ required: true })
    initialCustomer: Customer;

    customerList: Customer[] = [];
    
    activeCustomer: Customer;

    mounted() {
        // Get customers for user
        Session.shared.authenticatedServer.request({
            method: "GET",
            path: "/customers/customers",
            decoder: new ArrayDecoder(Customer as Decoder<Customer>)
        }).then(response => {
            this.customerList = response.data;
            this.activeCustomer = this.customerList[0];
            this.customerList.sort((a,b) => a.settings.businessName.localeCompare(b.settings.businessName));
        })
    }

    get selectedProfile(): string {
        return this.activeCustomer.id;
    }

    set selectedProfile(profileId: string) {
        this.activeCustomer = this.customerList.find(c => c.id === profileId) ?? this.activeCustomer;
        this.changeProfile();
    }

    addProfile() {
        this.show(new ComponentWithProperties(ChooseWholesalerView, {
            callback: (newCustomer: Customer) => {
                if (this.customerList.some(c => c.wholesaler.id !== newCustomer.wholesaler.id)) {
                    alert(this.$i18n.t('alerts.newCustomerWholesaler', { wholesalerName: newCustomer.wholesaler.settings.name }));
                }
                this.customerList.push(newCustomer);
                this.activeCustomer = newCustomer;
                this.pop();
                this.changeProfile();
            }
        }));
    }

    changeProfile() {
        if (this.initialCustomer.id !== this.activeCustomer.id) {
            Session.shared.authenticatedServer.request({
                method: "PATCH",
                path: "/auth/user",
                body: { defaultCustomerId: this.activeCustomer.id },
                decoder: User as Decoder<User>
            }).then(() => {
                window.location.reload();
            }).catch(() => {
                console.error("Failed to change profile")
            })
        }
    }
}
</script>